import React from "react";
import cn from "classnames";

import { SpriteIcon } from "@litres-libs/sprite-icons";
import { useTranslation } from "@litres-libs/i18n";

import type { ILabelProps } from "./types";
import { getFormat } from "./utils";

import styles from "./Label.module.scss";

export const Label = (props: ILabelProps) => {
  let { t } = useTranslation();
  if (props.t) {
    t = props.t;
  }
  const { type, format } = getFormat(props);

  if (type === "mini" && format.icon) {
    return (
      <div
        className={cn(styles.wrapper, props.labelClass)}
        data-testid="label-format__wrapper"
      >
        <span className={styles.wrapper__srLabel}>{t(format.label)}</span>
        <div
          className={cn(
            styles.format,
            styles.format_mini,
            styles.format_oneIcon
          )}
          aria-hidden="true"
        >
          <SpriteIcon name={format.icon} size={16} className={styles.icon} />
        </div>
      </div>
    );
  }

  if ((type === "midi" || type === "full") && format.status) {
    return (
      <div
        className={cn(styles.wrapper, props.labelClass)}
        data-testid="label-format__wrapper"
      >
        <span className={styles.wrapper__srLabel}>
          {t(format.label)} {t(format.status)}
        </span>
        {format.icon && (
          <div className={cn(styles.format, styles.format_oneIcon)}>
            <SpriteIcon name={format.icon} size={16} className={styles.icon} />
          </div>
        )}
        <div
          className={cn(styles.format, styles.format_status)}
          aria-hidden="true"
        >
          {t(format.status)}
        </div>
      </div>
    );
  }

  if (type === "midi") {
    return (
      <div
        className={cn(styles.wrapper, props.labelClass)}
        data-testid="label-format__wrapper"
        title={
          format.isSynced
            ? format.isForListen
              ? t("Аудиокнига, синхронизированная с текстовой")
              : t("Текстовая книга, синхронизированная с аудио")
            : format.linkIcon
              ? `${
                  format.isForListen
                    ? t("Аудиокнига с текстовой версией")
                    : t("Текстовая книга с аудиоверсией")
                }`
              : t(format.label)
        }
      >
        <span className={styles.wrapper__srLabel}>
          {t(format.label)}
          {format.linkIcon && format.isForReading
            ? ", " + t("доступен аудиоформат")
            : ""}
        </span>
        <div
          className={cn(styles.format, {
            [styles.format_sync]: format.isSynced,
            [styles.format_status]: !format.icon,
          })}
          aria-hidden="true"
        >
          {format.icon && (
            <SpriteIcon name={format.icon} size={16} className={styles.icon} />
          )}
          {format.linkIcon ? (
            <SpriteIcon
              name={format.linkIcon}
              size={16}
              className={styles.icon}
            />
          ) : (
            t(format.label)
          )}
        </div>
      </div>
    );
  }

  if (type === "full") {
    return (
      <div
        className={cn(styles.wrapper, props.labelClass)}
        data-testid="label-format__wrapper"
      >
        <div
          className={cn(styles.format, {
            [styles.format_status]: !format.icon,
          })}
        >
          {format.icon && (
            <SpriteIcon name={format.icon} size={16} className={styles.icon} />
          )}
          {t(format.label)}
        </div>
      </div>
    );
  }

  return null;
};
